import cx from 'classnames';
import * as React from 'react';

import Time from 'components/Time';
import MessageItemBody, {
  Props as MessageItemBodyProps,
} from './_shared/MessageItemBody/MessageItemBody';
import CurrentUser from 'auth/CurrentUser';
import { VideoChatMessageInviteItemFragment } from 'chat/components/Stream/fragments/__generated__/VideoChatMessageInviteItemFragment';

import 'chat/components/Stream/components/MessageItems/ChatMessageItem/ChatMessageItem.scss';

type Props = {
  message: VideoChatMessageInviteItemFragment;
  lastOfGroup: boolean;
};

type State = {
  hovered: boolean;
};

class VideoChatMessageInviteItem extends React.Component<Props, State> {
  state: State = {
    hovered: false,
  };

  isAuthor() {
    return CurrentUser.getUserUuid() === this.props.message.sender.uuid;
  }

  handleEnterHover = () => {
    this.setState({ hovered: true });
  };

  handleLeaveHover = () => {
    this.setState({ hovered: false });
  };

  renderHover() {
    const { message } = this.props;

    return (
      <div className="ChatMessageItem-hover">
        <div className="ChatMessageItem-hover-receipt">
          <Time date={new Date(message.createdAt)} hour="numeric" minute="2-digit" />
        </div>
      </div>
    );
  }

  render() {
    const { hovered } = this.state;

    const item = {
      ...this.props.message,
      body: `Click this link to join the video session: ${window.origin}/video/${this.props.message.sessionUUID}`,
    };

    return (
      <div
        className={cx('ChatMessageItem', {
          'ChatMessageItem-self': this.isAuthor(),
          'ChatMessageItem-other': !this.isAuthor(),
          'ChatMessageItem-hovered': hovered,
        })}
      >
        <div
          className="ChatMessageItem-row"
          onMouseEnter={this.handleEnterHover}
          onMouseLeave={this.handleLeaveHover}
        >
          {this.renderHover()}
          <div className="ChatMessageItem-container">
            <MessageItemBody item={item as unknown as MessageItemBodyProps['item']} />
          </div>
        </div>
      </div>
    );
  }
}

export default VideoChatMessageInviteItem;
